/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
/* eslint-disable import/prefer-default-export */

import Axios from 'axios';
import { iOS } from './platform-detection';

// Manifest file structure:
// { Root: Directories: {  }, Files: {} }
// Directory: { Directories: ..., Files: ... }
// File: { LocalPath: URL }

let manifest = null;

export function assetBasePath() {
  return 'https://assets.redmeru.com/';
}

export async function loadMasterAssetManifest() {
  // alert('loading');
  try {
    const response = await Axios.get(`${assetBasePath()}master/manifest.json`);

    if (!response) return; // alert('fail?');
    manifest = response.data;

    // eslint-disable-next-line no-use-before-define
    // alert(resolveAssetPath('CLG_inset_strike.jpg', 'images'));
    // alert(existsInManifest(resolveAssetPath('CLG_inset_strike.jpg', 'images')));
  } catch (err) {
    // alert(`fail = ${err}`);
    console.error(err);
  }
}

export function defaultEnvironmentBasePath() {
  // return `https://assets.redmeru.com/${process.env.DEFAULT_ASSET_ENVIRONMENT || 'master'}`;

  // We used to use the default for the enviroonment, but since nothing other than master is being
  // used, that seems pointless.
  return 'https://assets.redmeru.com/master';
}

export function privateAssetRoot() {
  return process.env.PRIVATE_ASSET_ROOT ? `private/${process.env.PRIVATE_ASSET_ROOT}` : '';
}

export function resolveAssetPath(path, oldBaseDir) {
  if (!path || path === '' || path.startsWith('https://')) {
    return encodeURI(path);
  }
  return `${defaultEnvironmentBasePath()}/${oldBaseDir}/${path}`;
}

export function resolvedAssetPathToRelativePath(path) {
  const base = assetBasePath();
  const p = path.substring(base.length + 1);
  const idx = p.indexOf('/');
  if (idx < 0) return undefined;
  return p.substring(idx + 1);
}

// Preloading logic
const oldDirs = ['backgrounds', 'characters', 'images'];
const preloadedImages = {};
const preloadedAudio = {};
let inFlightLoads = 0;

let preloadMisses = null;

const preloadCacheMissKey = '_bladePreloadMisses';
function loadPreload404s() {
  const data = localStorage.getItem(preloadCacheMissKey);

  if (data) {
    const temp = JSON.parse(data);

    // If the cache is a day old (or there's no save date), then skip
    if (!temp.lastSaved || Date.now() > (temp.lastSaved + 1000 * 60 * 60 * 24)) {
      console.error('clearing preload failure cache');
      return false;
    }
    preloadMisses = temp;
    console.log('preload misses');
    console.log(preloadMisses);
    return true;
  }

  preloadMisses = preloadMisses || {};
  for (const dir of oldDirs) {
    preloadMisses[dir] = preloadMisses[dir] || {};
  }

  console.error('no key found for preload cache');
  return false;
}

function savePreload404s() {
  preloadMisses = preloadMisses || {};
  console.log('saving preload 404');
  localStorage.setItem(preloadCacheMissKey,
    JSON.stringify({ ...preloadMisses, lastSaved: Date.now() }));
}

function storePreload404(asset, legacyDir) {
  preloadMisses = preloadMisses || {};
  preloadMisses[legacyDir] = preloadMisses[legacyDir] || {};
  preloadMisses[legacyDir][asset] = true;
  savePreload404s();
}

function isPreload404(asset, legacyDir) {
  preloadMisses = preloadMisses || {};
  const res = preloadMisses[legacyDir] ? preloadMisses[legacyDir][asset] : undefined;
  if (res === undefined) {
    console.log(`unknown for ${legacyDir}[${asset}]`);
    return false;
  }
  return true;
}

let anyLoadResolver = null;
let anyLoadWaiter = new Promise((resolve) => {
  anyLoadResolver = resolve;
});

async function markAssetLoadComplete() {
  if (anyLoadResolver) {
    anyLoadResolver();
    anyLoadResolver = null;
  }
}

async function limitPreloadRate() {
  // console.log(`checking rate limit, current loads == ${inFlightLoads}`);
  // while (inFlightLoads > rateLimit) {
  // console.log(`=> attempting rate limit, current loads == ${inFlightLoads}`);
  if (!anyLoadResolver) {
    // eslint-disable-next-line no-loop-func
    anyLoadWaiter = new Promise((resolve) => {
      anyLoadResolver = resolve;
    });
  }
  await anyLoadWaiter;
  // console.log(`=> rate limit done, current loads == ${inFlightLoads}`);
  // }
}

function existsInManifest(resolvedPath) {
  if (!manifest) return false;

  const recurse = (curDir) => {
    if (curDir.Files) {
      for (const fileIdx of Object.keys(curDir.Files)) {
        const fileObj = curDir.Files[fileIdx];
        if (fileObj.URL === resolvedPath) { return true; }
      }
    }

    if (curDir.Directories) {
      for (const dirIdx of Object.keys(curDir.Directories)) {
        if (recurse(curDir.Directories[dirIdx])) return true;
      }
    }
    return false;
  };

  if (manifest) {
    return recurse(manifest.Root);
  }
  return false;
}

function handleLegacyAsset(asset, promiseArray, rateLimit) {
  for (const dir of oldDirs) {
    const resolved = resolveAssetPath(asset, dir);
    if (existsInManifest(resolved) && !isPreload404(resolved, dir)) {
      // eslint-disable-next-line no-use-before-define
      preloadAsset(resolved, dir, promiseArray, undefined, rateLimit);
    } else {
    // console.log(`skipping 404'd asset ${dir}/${asset}`);
    }
  }
}

function preloadAsset(asset, legacyDir, promiseArray, matcher, rateLimit, skipLegacyAssets) {
  const lower = asset.toLowerCase();
  // TODO: other types?
  const isImage = lower.endsWith('png') || lower.endsWith('jpg') || lower.endsWith('jpeg') || lower.endsWith('gif');
  const isAudio = !isImage && (lower.endsWith('mp3') || lower.endsWith('ogg') || lower.endsWith('wav'));
  if (!(isImage || isAudio)) {
    return;
  }
  // console.log(`Preloading ${asset}...`);

  if (!asset.startsWith(assetBasePath())) {
    console.warn(`Warning: The asset ${asset} is using a legacy, relative path.  Please re-save any usages of this asset for more efficient preloading.`);

    // This is a relative path, so unless we're skipping it, we unfortunately need to try all of the old directories
    if (!skipLegacyAssets) {
      handleLegacyAsset(asset, promiseArray, rateLimit);
    }
    return;
  }

  if (isImage && preloadedImages[asset]) return Promise.resolve();
  if (isAudio && preloadedAudio[asset]) return Promise.resolve();
  if (matcher && !asset.match(matcher)) {
    // console.log(`Skipping asset ${asset} because it did not pass the matcher`);
    return;
  }

  const loader = new Promise(async(resolve) => {
    while (inFlightLoads > rateLimit) {
      await limitPreloadRate();
    }

    while (document.readyState !== 'complete') {
      await new Promise(resolveTimeout => setTimeout(resolveTimeout, 100));
    }

    ++inFlightLoads;
    if (isImage) {
      const image = new Image();
      image.src = asset;
      image.onload = () => {
        markAssetLoadComplete();
        --inFlightLoads;
        resolve();
      };

      image.onerror = () => {
        if (legacyDir) {
          storePreload404(asset, legacyDir);
        }
        markAssetLoadComplete();
        --inFlightLoads;
        resolve();
      };

      // Replace the asset key so the image stays in memory
      preloadedImages[asset] = image;
    } else if (isAudio) {
      const audio = new Audio();
      audio.src = asset;
      const eventName = iOS() ? 'loadedmetadata' : 'canplay';
      audio.addEventListener(eventName, () => {
        markAssetLoadComplete();
        --inFlightLoads;
        resolve();
      });

      audio.addEventListener('error', () => {
        if (legacyDir) {
          storePreload404(asset, legacyDir);
        }
        markAssetLoadComplete();
        --inFlightLoads;
        resolve();
      });

      // Replace the asset key so the audio stays in memory
      preloadedAudio[asset] = audio;
    }
  });

  if (isImage) {
    preloadedImages[asset] = asset;
  } else if (isAudio) {
    preloadedAudio[asset] = asset;
  }

  promiseArray.push(loader);
}

// All of the following is commented out because videos do not seem to be cached, so preloading
// them is a waste of time.

// async function internalPreloadVideo(asset, legacyDir, promiseArray) {
//   // // alert(`Trying to load video ${asset}`);
//   if (!asset.startsWith(assetBasePath())) {
// eslint-disable-next-line max-len
//     console.warn(`Warning: The asset ${asset} is using a legacy, relative path.  Please re-save any usages of this asset for more efficient preloading.`);
//     // This is a relative path, so we unfortunately need to try all of the old directories
//     for (const dir of oldDirs) {
//       const resolved = resolveAssetPath(asset, dir);
//       if (!isPreload404(resolved, dir)) {
//         await internalPreloadVideo(resolved, dir, promiseArray);
//       } else {
//         console.log(`skipping 404'd asset ${dir}/${asset}`);
//       }
//     }
//     return;
//   }

//   if (preloadedImages[asset]) return Promise.resolve();
//   // if (matcher && !asset.match(matcher)) {
//   //   console.log(`Skipping asset ${asset} because it did not pass the matcher`);
//   //   return;
//   // }

//   // We don't want to wait for the video, we just want it to load first
//   const video = document.createElement('video');
//   video.src = asset;
//   preloadedImages[asset] = asset;
//   promiseArray.push(Axios.get(asset));
//   // // alert(`Preloaded video from "${asset}"`);
// }

// function internalRecursivelyStartVideoLoads(obj, path, promiseArray, matcher) {
//   const type = typeof (obj);
//   switch (type) {
//     case 'string':
//     {
//       const lower = obj.toLowerCase();
//       if (lower.endsWith('mp4') || lower.endsWith('webm')) {
//         // console.log(`Preloading ${obj}...`);
//         internalPreloadVideo(obj, undefined, promiseArray, matcher);
//       }
//       break;
//     }
//     case 'object':
//     {
//       if (!obj) return;

//       if (Array.isArray(obj)) {
//         for (let i = 0; i < obj.length; ++i) {
// eslint-disable-next-line max-len
//           internalRecursivelyStartVideoLoads(obj[i], path.length === 0 ? i : `${path}[${i}]`, promiseArray, matcher);
//         }
//       }

//       // TODO: Handle maps
//       for (const k of Object.keys(obj)) {
//         // Ignore the assets module since it contains literally every image
//         if (k === 'bladeAssets') continue;
// eslint-disable-next-line max-len
//         internalRecursivelyStartVideoLoads(obj[k], path.length === 0 ? k : `${path}/${k}`, promiseArray, matcher);
//       }
//       break;
//     }
//     default:
//       break;
//   }
// }

// matcher is a regexp that limits the number of items to match against
async function internalPreloadAssetsFromObject(obj, path, promiseArray, matcher, rateLimit, skipLegacyAssets) {
  const type = typeof (obj);
  switch (type) {
    case 'string':
    {
      await preloadAsset(obj, undefined, promiseArray, matcher, rateLimit, skipLegacyAssets);
      break;
    }
    case 'object':
    {
      if (!obj) return;

      if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; ++i) {
          await internalPreloadAssetsFromObject(obj[i], path.length === 0 ? i : `${path}[${i}]`, promiseArray, matcher, rateLimit, skipLegacyAssets);
        }
      }

      // TODO: Handle maps
      for (const k of Object.keys(obj)) {
        // Ignore the assets module since it contains literally every image
        if (k === 'bladeAssets') continue;
        await internalPreloadAssetsFromObject(obj[k], path.length === 0 ? k : `${path}/${k}`, promiseArray, matcher, rateLimit, skipLegacyAssets);
      }
      break;
    }
    default:
      break;
  }
}

let initialPreloadComplete = false;
let initialPreloadResolver = null;
const initialPreloadWaiter = new Promise((resolve) => {
  initialPreloadResolver = resolve;
});

// const initialPreloadCache = [];

// matcher is a regexp that matches asset paths
export async function preloadAssetsFromObject(
  target,
  waitForInitialLoad,
  matcher,
  completionPercentCallback,
  skipLegacyAssets
) {
  try {
    if (waitForInitialLoad && !initialPreloadComplete) {
      await initialPreloadWaiter;
    }

    // If the key isn't there, save it
    if (!preloadMisses) {
      if (!loadPreload404s()) {
        savePreload404s();
      }
    }
    const clone = JSON.parse(JSON.stringify(target));
    const promiseArray = [];

    // Browsers don't cache mp4 files apparently
    // if (!initialPreloadCache) {
    //   internalRecursivelyStartVideoLoads(clone, '{root}', promiseArray, matcher);
    // }

    await internalPreloadAssetsFromObject(clone, '{root}', promiseArray, matcher, initialPreloadComplete ? 2 : 20, skipLegacyAssets);

    if (completionPercentCallback) {
      let completed = 0;
      const total = promiseArray.length;
      for (let i = 0; i < promiseArray.length; i++) {
        // eslint-disable-next-line no-loop-func
        promiseArray[i].then(() => {
          ++completed;
          completionPercentCallback(Math.round(completed / total * 100));
        });
      }
    }

    await Promise.all(promiseArray);
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export function markInitialGamePreloadComplete() {
  initialPreloadComplete = true;
  initialPreloadResolver();
  // preloadAssetsFromObject(initialPreloadCache, undefined, undefined, undefined, skipLegacyAssets);
}



// WEBPACK FOOTER //
// ./src/utils/asset-util.js